export default "__VITE_ASSET__9tIMgpuq__"